{
	"name": "miniflare",
	"version": "4.20260526.0",
	"description": "Fun, full-featured, fully-local simulator for Cloudflare Workers",
	"keywords": [
		"cloudflare",
		"cloudworker",
		"local",
		"worker",
		"workers"
	],
	"homepage": "https://github.com/cloudflare/workers-sdk/tree/main/packages/miniflare#readme",
	"bugs": {
		"url": "https://github.com/cloudflare/workers-sdk/issues"
	},
	"license": "MIT",
	"author": "MrBBot <me@mrbbot.dev>",
	"repository": {
		"type": "git",
		"url": "https://github.com/cloudflare/workers-sdk.git",
		"directory": "packages/miniflare"
	},
	"bin": {
		"miniflare": "bootstrap.js"
	},
	"files": [
		"dist/src",
		"dist/local-explorer-ui",
		"bootstrap.js"
	],
	"main": "./dist/src/index.js",
	"types": "./dist/src/index.d.ts",
	"publishConfig": {
		"access": "public"
	},
	"scripts": {
		"build": "node scripts/build.mjs && pnpm run types:build",
		"capnp:workerd": "capnp-es node_modules/workerd/workerd.capnp -ots:src/runtime/config/generated --src-prefix=node_modules/workerd",
		"check:generate-api": "node -r esbuild-register scripts/check-generate-api.ts",
		"check:type": "tsc",
		"clean": "node -r esbuild-register ../../tools/clean/clean.ts ./dist ./dist-types",
		"dev": "concurrently -n esbuild,typechk,typewrk -c yellow,blue,blue.dim \"node scripts/build.mjs --watch\" \"node scripts/types.mjs tsconfig.json --bundle --watch\" \"node scripts/types.mjs src/workers/tsconfig.json --watch\"",
		"generate:api": "pnpm generate:openapi && pnpm generate:types",
		"generate:openapi": "node -r esbuild-register scripts/filter-openapi.ts -i $OPENAPI_INPUT_PATH",
		"generate:types": "openapi-ts && oxfmt src/workers/local-explorer/openapi.local.json src/workers/local-explorer/generated",
		"test": "vitest run",
		"posttest": "node -r esbuild-register ../../tools/clean/clean.ts ./.tmp",
		"test:ci": "pnpm run test",
		"types:build": "node scripts/types.mjs tsconfig.json --bundle && node scripts/types.mjs src/workers/tsconfig.json"
	},
	"dependencies": {
		"@cspotcode/source-map-support": "0.8.1",
		"sharp": "^0.34.5",
		"undici": "catalog:default",
		"workerd": "1.20260526.1",
		"ws": "catalog:default",
		"youch": "4.1.0-beta.10"
	},
	"devDependencies": {
		"@cloudflare/cli-shared-helpers": "workspace:*",
		"@cloudflare/containers-shared": "workspace:*",
		"@cloudflare/kv-asset-handler": "workspace:*",
		"@cloudflare/local-explorer-ui": "workspace:*",
		"@cloudflare/workers-shared": "workspace:*",
		"@cloudflare/workers-types": "catalog:default",
		"@cloudflare/workers-utils": "workspace:*",
		"@cloudflare/workflows-shared": "workspace:*",
		"@hey-api/openapi-ts": "catalog:default",
		"@microsoft/api-extractor": "^7.52.8",
		"@puppeteer/browsers": "^2.10.6",
		"@types/debug": "^4.1.7",
		"@types/estree": "^1.0.0",
		"@types/glob-to-regexp": "^0.4.1",
		"@types/http-cache-semantics": "^4.0.1",
		"@types/mime": "^3.0.4",
		"@types/node": "catalog:default",
		"@types/stoppable": "^1.1.1",
		"@types/which": "^2.0.1",
		"@types/ws": "^8.5.7",
		"acorn": "8.16.0",
		"acorn-import-phases": "^1.0.4",
		"acorn-walk": "8.3.5",
		"capnp-es": "catalog:default",
		"capnweb": "catalog:default",
		"chokidar": "^4.0.1",
		"ci-info": "catalog:default",
		"concurrently": "^8.2.2",
		"devalue": "^5.6.3",
		"devtools-protocol": "^0.0.1182435",
		"esbuild": "catalog:default",
		"expect-type": "^0.15.0",
		"get-port": "^7.1.0",
		"glob-to-regexp": "0.4.1",
		"hono": "^4.12.5",
		"http-cache-semantics": "^4.1.0",
		"jsonc-parser": "catalog:default",
		"kleur": "^4.1.5",
		"mime": "^3.0.0",
		"postal-mime": "^2.4.3",
		"pretty-bytes": "^6.0.0",
		"source-map": "^0.6.1",
		"stoppable": "1.1.0",
		"ts-dedent": "^2.2.0",
		"typescript": "catalog:default",
		"vitest": "catalog:default",
		"which": "^2.0.2",
		"xdg-app-paths": "^8.3.0",
		"zod": "^3.25.76"
	},
	"engines": {
		"node": ">=22.0.0"
	},
	"volta": {
		"extends": "../../package.json"
	},
	"workers-sdk": {
		"prerelease": true
	}
}
